module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/in-avatar-2ff135ad65e0c5d34ead98734038017c.png";